import { api } from '@/lib/api';
import type {
  InterventionReport,
  InterventionReportFilters,
  InterventionReportsPage,
} from './types';

export function listInterventionReports(
  accountId: string,
  filters: InterventionReportFilters,
): Promise<InterventionReportsPage> {
  return api.get<InterventionReportsPage>('/v4/intervention-reports', {
    accountId,
    search: filters.search,
    outcome: filters.outcome,
    from: filters.from,
    to: filters.to,
    pageNumber: filters.pageNumber,
    pageLength: filters.pageLength,
  });
}

export async function getInterventionReport(accountId: string, reportId: string): Promise<InterventionReport> {
  const response = await api.get<{ report: InterventionReport }>(
    `/v4/intervention-reports/${encodeURIComponent(reportId)}`,
    { accountId },
  );
  return response.report;
}

export async function getInterventionPhotoUrl(
  accountId: string,
  reportId: string,
  photoId: string,
): Promise<string> {
  const response = await api.get<{ url: string }>(
    `/v4/intervention-reports/${encodeURIComponent(reportId)}/photos/${encodeURIComponent(photoId)}`,
    { accountId },
  );
  return response.url;
}
